import { evalCondition } from 'mailup-react-helpers'

export const isOfferLight = () => {
  return evalCondition('c:IsOfferLight')
}
